<template>
  <div>
    <DashboardHeader title="Students Owing">
      <v-layout>
        <Loader></Loader>
        <v-flex class="mx-2" xs12 md2>
          <SelectClassComponent class="mt-4 mx-4" @selected-class="getOwingForSelectedClass"></SelectClassComponent>

          <v-card
            v-if="selectedClass && classTotalDue != null"
            shaped
            elevation="12"
            class="mt-4 mx-4"
            outlined
          >
            <v-list-item three-line>
              <v-btn
                dark
                class="mx-auto"
                block
                :color="getThemeColor"
                solo-inverted
                rounded
                hide-details
                @click="printPDF()"
              >Generate PDF</v-btn>
            </v-list-item>
          </v-card>

          <v-card
            class="mx-4 mt-4"
            v-if="selectedClass && classTotalDue != null"
            shaped
            elevation="12"
            max-width="344"
            outlined
          >
            <v-list-item three-line>
              <v-list-item-content>
                <div class="overline mb-4">Class Finance Summary</div>
                <v-list-item-title class="title mb-1">Class: {{selectedClass}}</v-list-item-title>
                <v-list-item-subtitle>Manager: {{classObj.class_teacher}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list two-line>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon :color="getThemeColor">mdi-credit-card</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{getCurrency}} {{classTotalDue}}</v-list-item-title>
                  <v-list-item-subtitle>Total Due</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon :color="getThemeColor">mdi-credit-card-plus</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{getCurrency}} {{classTotalPaid}}</v-list-item-title>
                  <v-list-item-subtitle>Total Paid</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon :color="getThemeColor">mdi-credit-card-minus</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{getCurrency}} {{classTotalExpected}}</v-list-item-title>
                  <v-list-item-subtitle>Total Outstanding</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-flex>
        <v-flex class="mx-2 mt-4" xs12 md9>
          <v-card>
            <v-card-title>
              Students Owing
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="students" :search="search"></v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </DashboardHeader>
  </div>
</template>

<script>
import DashboardHeader from "@/components/DashboardHeader.vue";
import axios from "@/plugins/axios";
import SelectClassComponent from "@/components/GeneralComponents/SelectClassComponent.vue";
import Loader from "@/components/Loader.vue";

export default {
  components: { DashboardHeader, SelectClassComponent, Loader },
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    getUserSchool() { 
      return this.$store.getters.getUserSchool
    }
  },

  data: () => ({
    selectedClass: null,
    students: [],
    classTotalDue: null,
    classObj: null,
    selDate: null,
    classTotalPaid: null,
    classTotalExpected: null,
    search: null,
    headers: [
      {
        text: "SID",
        align: "start",
        sortable: false,
        value: "sid"
      },
      { text: "Full Names", value: "fullnames" },
      { text: "Total Due (ZAR)", value: "totalDue" },
      { text: "Total Paid (ZAR)", value: "totalPaid" },
      { text: "Balance (ZAR)", value: "balance" },
      {
        text: "Previous Months Arrears",
        value: "expectedPaidExcludingCurrentMonth"
      },
      { text: "Min. Exp. Pymt (ZAR)", value: "mep" }
    ]
  }),
  methods: {
    printPDF() {
      this.$router.push({
        name: "students-owing-pdf-list",
        params: {
          students: this.students,
          headers: this.headers,
          classTotalDue: this.classTotalDue,
          classTotalPaid: this.classTotalPaid,
          classTotalExpected: this.classTotalExpected,
          selDate: this.selDate,
          classObj: this.classObj,
          selectedClass: this.selectedClass
        }
      });
    },
    getOwingForSelectedClass(selectedClass) {
      this.selectedClass = selectedClass;
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/students-owing-for-given-class",
          { selectedClass },
          this.getAccessToken
        )
        .then(studentsData => {
          this.$store.commit("setLoader", false);
          if (this.getUserSchool.emis == '500342065' || this.getUserSchool.emis == '500499130') {
            this.students = studentsData[0];
           } else {
            this.students = studentsData[0].filter(student => {
            return student.balDueMonth > 0 && student.balDueYear > 0;
          });
          }
          
          this.classTotalDue = studentsData[1];
          this.classTotalPaid = studentsData[2];
          this.classTotalExpected = studentsData[3];
          this.selDate = studentsData[4];
          this.classObj = studentsData[5];
        });
    }
  }
};
</script>

<style>
</style>